module.exports = __webpack_public_path__ + "static/media/selection.a4c1c83a.svg";